import classNames from "classnames";
import styles from "./style.module.scss";

export interface FloatingDetails {
  type: "success" | "default" | "danger";
  value: string;
}
interface ReviewFloatingDetailsProps {
  floatingDetails: FloatingDetails;
  className?: string;
}

export default function ReviewFloatingDetails({
  floatingDetails,
  className,
}: ReviewFloatingDetailsProps) {
  const floatingDetailsClassnames = classNames(
    styles.floatingDetails,
    className,
    {
      [styles[floatingDetails.type]]: floatingDetails.type,
    },
  );

  return (
    <div className={floatingDetailsClassnames}>{floatingDetails.value}</div>
  );
}
